const mutationKeys = {
  ASSIGN_MEMBER: 'ASSIGN_MEMBER',
  THREAD_ACTION: 'THREAD_ACTION',
  ADD_PARTICIPANT: 'ADD_PARTICIPANT',
  REMOVE_PARTICIPANT: 'REMOVE_PARTICIPANT',
  SAVE_TIME_ENTRY: 'SAVE_TIME_ENTRY'
};

export default mutationKeys;
